import React from 'react';
import './HeaderMain.css';
const HeaderMain = () => {



    return (
        <main className="row d-flex align-items-center container-fluid">
            <div className="col-md-5  ml-5 inner">
                <h1 className="text-white">Happy Wedding</h1>
                <p className="">A wedding is a ceremony where two people are united in marriage. Wedding traditions and customs vary greatly between cultures, ethnic groups, religions, countries, and social classes.</p>
                <button id="button"><span>OUR PORTFOLIO</span></button>
            </div>
            <div className="col-md-6 slider mb-5">
            

            </div>
            
        </main>
    );
};

export default HeaderMain;